import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home/index";
import Burst from "./views/burst/Burst";
import Partner from "./views/partner/Partner";
import SystemNotification from "./views/notification/SystemNotification";

import store from "./store";

Vue.use(Router);

let router = new Router({
//   mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/home",
      name: "home",
      component: Home,
    },
    {
      path: "/mall",
      name: "mall",
      component: () =>
        import(/* webpackChunkName: "mall" */ "./views/mall/index.vue"),
    },
    {
      path: "/mall/detail",
      name: "mallDetail",
      component: () =>
        import(/* webpackChunkName: "mallDetail" */ "./views/mall/detail.vue"),
    },
    {
      path: "/news",
      name: "news",
      component: () =>
        import(/* webpackChunkName: "news" */ "./views/news/index.vue"),
    },
    {
      path: "/newsDetail",
      name: "newsDetail",
      component: () =>
        import(/* webpackChunkName: "newsDetail" */ "./views/news/detail.vue"),
    },
    {
      path: "/wallet",
      name: "wallet",
      component: () =>
        import(/* webpackChunkName: "wallet" */ "./views/wallet/index.vue"),
    },
    {
      path: "/question",
      name: "question",
      component: () =>
        import(/* webpackChunkName: "question" */ "./views/question/index.vue"),
    },
    {
      path: "/user",
      name: "quesusertion",
      component: () =>
        import(/* webpackChunkName: "user" */ "./views/user/index.vue"),
    },
    {
      path: "/market",
      name: "market",
      component: () =>
        import(/* webpackChunkName: "market" */ "./views/market/index.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "Login" */ "./views/login/Login.vue"),
    },
    {
      path: "/forgetPassword",
      name: "forgetPassword",
      component: () =>
        import(
          /* webpackChunkName: "ForgetPassword" */ "./views/login/ForgetPassword.vue"
        ),
    },
    {
      path: "/editPassword",
      name: "editPassword",
      component: () =>
        import(
          /* webpackChunkName: "EditPassword" */ "./views/login/EditPassword.vue"
        ),
    },
    {
      path: "/register",
      name: "register",
      component: () =>
        import(/* webpackChunkName: "register" */ "./views/login/Register.vue"),
    },
    {
      path: "/ctc",
      name: "ctc",
      component: () =>
        import(/* webpackChunkName: "ctc" */ "./views/ctc/CTC.vue"),
    },
    {
      path: "/download",
      name: "download",
      component: () =>
        import(/* webpackChunkName: "footerDownload" */ "./views/download/download.vue"),
    },
	{
	  path: "/app",
	  name: "app",
	  component: () =>
	    import(/* webpackChunkName: "footerDownload" */ "./views/download/download-app.vue"),
	},
    {
      path: "/footerAbout",
      name: "footerAbout",
      component: () =>
        import(/* webpackChunkName: "footerAbout" */ "./views/footer/about.vue"),
    },
    {
      path: "/footerPrivacy",
      name: "footerPrivacy",
      component: () =>
        import(/* webpackChunkName: "footerPrivacy" */ "./views/footer/privacy.vue"),
    },
    {
      path: "/footerAgreement",
      name: "footerAgreement",
      component: () =>
        import(/* webpackChunkName: "footerAgreement" */ "./views/footer/agreement.vue"),
    },
	{
	  path: "/footerBuyProtocol",
	  name: "footerBuyProtocol",
	  component: () =>
	    import(/* webpackChunkName: "footerAgreement" */ "./views/footer/buy-protocol.vue"),
	},
    {
      path: "/footerAddress",
      name: "footerAddress",
      component: () =>
        import(/* webpackChunkName: "footerAddress" */ "./views/footer/address.vue"),
    },
    {
      path: "/partner",
      name: "partner",
      component: () =>
        import(/* webpackChunkName: "partnerProgram" */ "./views/partner/partnerProgram.vue"),
    },
    {
      path: "/DIMDDetail",
      name: "DIMDDetail",
      component: () =>
        import(/* webpackChunkName: "DIMDDetail" */ "./views/coin/DIMDDetail.vue"),
    },
    {
      path: "/GCTDetail",
      name: "GCTDetail",
      component: () =>
        import(/* webpackChunkName: "GCTDetail" */ "./views/coin/GCTDetail.vue"),
    }
  ],
});

//导航守卫
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;

  store.commit("updateRouter", to); //更新store中存储的当前路径
  if (window.localStorage.getItem("jwt-token") && !store.state.user.username) {
    if (to.path === "/login" || to.path === "/register") {
      next();
    } else {
      store.dispatch("actions_getUserInfo").then((res) => {
        next();
      });
    }
  } else {
    next();
  }
});

export default router;
